import { performOCR } from '../../services/visionAPI';
import { extractBoxDimensionsFromOcr, type BoxDimensions } from './parseBoxDimensions';

export const BOX_SCAN_STATUSES = {
  MATCHED: 'matched',
  NO_TEXT: 'no_text',
  NO_DIMS: 'no_dims',
} as const;

export type BoxDimensionScanResult =
  | { readonly status: typeof BOX_SCAN_STATUSES.MATCHED; readonly dims: BoxDimensions }
  | { readonly status: typeof BOX_SCAN_STATUSES.NO_TEXT }
  | { readonly status: typeof BOX_SCAN_STATUSES.NO_DIMS; readonly ocrText: string };

export const BOX_SCAN_NO_TEXT_MESSAGE = 'Error processing image. Please try again.';

export function boxScanNoDimsMessage(ocrText: string): string {
  return `Could not find box size. Scan input: ${ocrText}`;
}

/** OCR a captured frame (JPEG data URL) and pull the first plausible L × W × H. */
export async function readBoxDimensionsFromImage(imageSrc: string): Promise<BoxDimensionScanResult> {
  const ocrText = await performOCR(imageSrc);
  if (!ocrText) {
    return { status: BOX_SCAN_STATUSES.NO_TEXT };
  }
  const dims = extractBoxDimensionsFromOcr(ocrText);
  if (!dims) {
    return { status: BOX_SCAN_STATUSES.NO_DIMS, ocrText };
  }
  return { status: BOX_SCAN_STATUSES.MATCHED, dims };
}
